import { useResponsiveItems } from './use-responsive-items.hook';

export function ResponsiveList() {
  const items = useResponsiveItems();

  return (
    <div className="flex flex-col space-y-2">
      {items.map((item) => (
        <span key={item.label} className="flex px-2 py-1">
          <span data-testid={`header-${item.label}`}>{!item.hideLabel && `${item.label}:`}</span>
          <div className="pl-1" data-testid={`header-${item.label}-value`}>
            {item.value}
          </div>
        </span>
      ))}
    </div>
  );
}
